module.exports = __webpack_public_path__ + "img/sen_vibe.115354ec.png";